import styled from 'styled-components';
import { HistoryGraphContainer } from 'pages/NewOverview/styles';
import { CardsGraphContainer } from '../styles';

export const TrendsCardContainer = styled(HistoryGraphContainer)<{ expandedSplit: boolean }>`
  width: ${({ expandedSplit }) => (expandedSplit ? '50%' : '500px')};
  height: 364px;
  display: flex;
  gap: 20px;
  position: relative;

  @media (max-width: 768px) {
    height: 435px;
    width: 100%;
  }
`;

export const TrendsCardsGraphContainer = styled(CardsGraphContainer)`
  @media (max-width: 768px) {
    margin: 0 -8px;
  }
`;
